import { initModule } from './init-module';

initModule();

export { FormsLibraryRoutes } from './forms-library.routes';

export { formsLibrary } from './forms-library.config';

export { flRoutesMap } from './init-module';
